// extracted by mini-css-extract-plugin
export default {"formSection":"SectionForm_formSection__05f-+","formTitle":"SectionForm_formTitle__yjGiJ","formTitleWrapper":"SectionForm_formTitleWrapper__BW6au"};